import React, { Component } from 'react';
import { Modal, Button, Row, Table, Tag, Popover } from 'antd/lib';
import _ from 'lodash';
import moment from 'moment';
import { withApollo } from 'react-apollo';

const colores = {
  denunciante: 'Goldenrod',
  'denunciante 2212/2302': 'Goldenrod',
  recurrente: 'Goldenrod',
  'otra persona': 'darkcyan',
  testigo: 'darkcyan',
  'tercero citado': 'darkcyan',
  'citado en garantia': 'darkcyan',
  tercero: 'darkcyan',
  tercerista: 'darkcyan',
  interesado: 'paleturquoise',
  menor: 'lightblue',
  'victima menor': 'lightblue',
  'menor (niño)': 'lightblue',
  'testigo menor': 'lightblue',
  'perito en la causa (directo)': 'grey',
  'profesionales auxiliares': 'grey',
  'fiscal de estado': 'grey',
  querellante: 'grey',
  fiscal: 'grey',
  'representante legal': 'grey',
  martillero: 'grey',
  'administrador judicial de sucesion': 'grey',
  enajenador: 'grey',
  'ministerio publico': 'grey',
  guardador: 'grey',
  insano: 'darkgrey',
  denunciado: 'orange',
  fallecido: 'black',
  fallido: 'black',
  demandado: 'Crimson',
  imputado: 'Crimson',
  causante: 'Crimson',
  condenado: 'Crimson',
  incidentista: 'Crimson',
  'concursado o quebrado': 'Crimson',
  victima: 'OliveDrab',
  damnificado: 'OliveDrab',
  incidentado: 'OliveDrab',
  actor: 'SeaGreen',
  peticionante: 'SeaGreen',
  cobrador: 'OliveDrab',
  sindico: 'OliveDrab',
  acreedor: 'OliveDrab',
  heredero: 'RosyBrown',
  madre: 'RosyBrown',
  padre: 'RosyBrown',
  familiar: 'RosyBrown',
  'acreedor hipotecario': 'RosyBrown',
  conyuge: 'RosyBrown',
  'familiar a cargo': 'teal',
  'curador definitivo': 'teal',
  'curador ad-bona': 'teal',
  'a cargo': 'teal',
  curador: 'teal',
};

class ModalBuscarAntecedentes extends Component {
  sortExpediente = (a, b) => {
    // console.log('ME entra... ', a, b);

    if (a.anio > b.anio) {
      // console.log("A");
      return 1;
    }
    if (a.anio < b.anio) {
      // console.log("B");
      return -1;
    }

    if (a.anio == b.anio) {
      // console.log("C");
      return 0;
    }
  };

  render() {
    // console.log('PROPS');
    // console.log(this.props);

    const columns = [
      {
        title: 'Expediente',
        key: 'expediente',
        render: expediente =>
          expediente.codigoOrganismo +
          ' ' +
          expediente.tipo.nombre +
          ' ' +
          expediente.numero +
          ' ' +
          expediente.anio,
      },
      {
        title: 'Fecha del Hecho',
        key: 'fechaHecho',
        render: expediente =>
          expediente.fechaHecho
            ? moment(expediente.fechaHecho).format('DD/MM/YYYY')
            : 'SIN DATOS',
      },
      {
        title: 'Organismo',
        key: 'organismo[nombre]',
        dataIndex: ['organismo', 'nombre'],
      },
      {
        title: 'Estado Sancion',
        key: 'estadoSancion',
        render: expediente => {
          let res;
          _.forEach(expediente.contraventores, contraventor => {
            if (contraventor.persona._id == this.props.persona._id) {
              switch (contraventor.estado) {
                case 'PRESUNTO CONTRAVENTOR':
                  res = (
                    <Tag key={contraventor.estado} color="orange">
                      PRESUNTO CONTRAVENTOR
                    </Tag>
                  );
                  break;
                case 'SANCIONADO':
                  res = (
                    <Tag key={contraventor.estado} color="red">
                      SANCIONADO
                    </Tag>
                  );
                  break;
                case 'ABSUELTO':
                  res = (
                    <Tag key={contraventor.estado} color="green">
                      ABSUELTO
                    </Tag>
                  );
                  break;
              }
            }
          });
          return res;
        },
      },
      {
        title: 'Fecha Sancion',
        key: 'fechaSancion',
        render: expediente => {
          let res = '';
          _.forEach(expediente.contraventores, contraventor => {
            if (contraventor.persona._id == this.props.persona._id) {
              if (contraventor.sancion && contraventor.sancion.fechaSancion) {
                res = moment(contraventor.sancion.fechaSancion).format(
                  'DD/MM/YYYY'
                );
              } else {
                res = 'SIN DATOS';
              }
            }
          });
          return res;
        },
      },
      {
        title: 'Articulos',
        key: 'articulos',
        render: expediente => {
          let articulos = '';
          _.forEach(expediente.contraventores, contraventor => {
            if (contraventor.persona._id == this.props.persona._id) {
              if (contraventor.sancion && contraventor.sancion.articulos) {
                _.forEach(contraventor.sancion.articulos, articulo => {
                  articulos += ' ' + articulo.nombre;
                });
              } else {
                articulos = 'SIN DATOS';
              }
            }
          });
          return articulos;
        },
      },
    ];

    const columns2 = [
      {
        title: 'Expediente',
        key: 'expediente',
        sorter: (a, b) => this.sortExpediente(a.expediente, b.expediente),
        defaultSortOrder: 'descend',
        dataIndex: 'expediente',
        render: expediente =>
          expediente.organismo +
          ' ' +
          expediente.tipo +
          ' ' +
          expediente.numero +
          ' ' +
          expediente.anio,
      },
      {
        title: 'Caratula',
        key: 'caratulaExpediente',
        dataIndex: 'expediente',
        render: expediente => (
          <Popover content={expediente.caratula} title="Caratula">
            {expediente.caratula.length > 75
              ? expediente.caratula.slice(0, 75).concat('...')
              : expediente.caratula}
          </Popover>
        ),
      },
      {
        title: 'Fuero',
        key: 'fueroExpediente',
        dataIndex: 'expediente',
        render: expediente => (
          <Popover content={expediente.fuero} title="Fuero">
            {expediente.fuero && expediente.fuero.length > 40
              ? expediente.fuero.slice(0, 40).concat('...')
              : expediente.fuero}
          </Popover>
        ),
      },
      {
        title: 'Tipo Vinculo',
        key: 'tipoVinculo',
        dataIndex: 'tipoVinculo',
        render: tipoVinculo => {
          let res;

          let color = _.get(colores, tipoVinculo.toLowerCase(), 'black');
          res = (
            <Tag
              key={tipoVinculo}
              color={color}
              style={{ width: '140px', textAlign: 'center' }}
            >
              <Popover content={tipoVinculo.toUpperCase()} title="Tipo Vinculo">
                {tipoVinculo.toUpperCase() &&
                tipoVinculo.toUpperCase().length > 11
                  ? tipoVinculo
                      .toUpperCase()
                      .slice(0, 11)
                      .concat('...')
                  : tipoVinculo.toUpperCase()}
              </Popover>
            </Tag>
          );
          return res;
        },
      },
    ];

    let persona = this.props.persona || {
      apellido: '',
      nombre: '',
    };

    return (
      <div>
        <Modal
          title={'Antecedentes de: ' + persona.apellido + ' ' + persona.nombre}
          visible={this.props.mostrarModalAntecedentes}
          onCancel={this.props.ocultarModalAntecendetes}
          width={1200}
          footer={[
            <Button key="back" onClick={this.props.ocultarModalAntecendetes}>
              Volver
            </Button>,
          ]}
        >
          {this.props.expedientes.length > 0 && (
            <div>
              <h3> ANTECEDENTES EN LA JUSTICIA DE PAZ </h3>
              <br />
              <Row>
                <Table
                  className="tablaAntecedentes"
                  rowKey="_id"
                  columns={columns}
                  size="small"
                  pagination={false}
                  dataSource={this.props.expedientes}
                />
              </Row>
            </div>
          )}

          <br />
          {this.props.expedientesExternos &&
            this.props.expedientesExternos.length > 0 && (
              <div>
                <h3> ANTECEDENTES EXTERNOS A LA JUSTICIA DE PAZ </h3>
                <br />
                <Row>
                  <Table
                    className="tablaAntecedentes"
                    rowKey={record => {
                      return record.expediente.numero;
                    }}
                    columns={columns2}
                    size="small"
                    pagination={false}
                    dataSource={this.props.expedientesExternos}
                  />
                </Row>
              </div>
            )}

          <br />
          {this.props.expedientesExternos.length <= 0 &&
            this.props.expedientes.length <= 0 && (
              <div>
                <h3> LA PERSONA NO POSEE ANTECEDENTES </h3>
                <br />
              </div>
            )}
        </Modal>
      </div>
    );
  }
}

export default withApollo(ModalBuscarAntecedentes);
